import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { Reveal } from "@/components/site/Reveal";
import PledgeTicker from "@/components/site/PledgeTicker";
import { useAmazonLink } from "@/hooks/useAmazonLink";
import { ASSETS } from "@/lib/site";

export default function Checkout() {
  const { link: amazonLink } = useAmazonLink();
  return (
    <section
      data-testid="checkout-section"
      className="relative overflow-hidden border-t border-white/10 bg-panel py-28 md:py-40"
    >
      <div className="mx-auto grid max-w-6xl grid-cols-1 items-center gap-16 px-6 md:px-12 lg:grid-cols-2">
        <div>
          <Reveal>
            <p className="mb-5 font-mono text-xs uppercase tracking-[0.3em] text-rebellion">
              The Rebellion Starts Here
            </p>
          </Reveal>
          <Reveal delay={0.05}>
            <h2 className="font-display text-5xl uppercase leading-[0.9] tracking-tight text-paper sm:text-6xl md:text-7xl">
              Claim Your <span className="text-rebellion">Rights.</span>
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="mt-6 max-w-md font-editorial text-xl leading-relaxed text-white/60 md:text-2xl">
              A short book, but the kind you close with an argument still
              running in your head. Take it home, sit with it, disagree freely.
            </p>
          </Reveal>
          <Reveal delay={0.15}>
            <a
              data-testid="checkout-buy-button"
              href={amazonLink}
              target="_blank"
              rel="noopener noreferrer"
              className="group mt-10 inline-flex items-center gap-4 overflow-hidden border border-rebellion bg-rebellion px-10 py-5 font-mono text-sm font-bold uppercase tracking-[0.25em] text-white transition-colors duration-300 hover:bg-white hover:text-rebellion"
            >
              Buy on Amazon
              <ArrowUpRight className="h-5 w-5 transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1" />
            </a>
          </Reveal>
          <Reveal delay={0.2}>
            <PledgeTicker />
          </Reveal>
        </div>

        <Reveal delay={0.2} className="flex justify-center lg:justify-end">
          <motion.div
            whileHover={{ rotate: 2, scale: 1.02 }}
            transition={{ duration: 0.5, ease: "easeOut" }}
            className="relative w-[62%] sm:w-[48%] lg:w-[78%]"
          >
            <div className="absolute -inset-5 -z-10 bg-rebellion/25 blur-3xl" />
            <div className="border border-white/15 shadow-[20px_20px_60px_rgba(0,0,0,0.8)]">
              <img
                data-testid="checkout-cover-image"
                src={ASSETS.cover}
                alt="Election on Mars book cover"
                className="block w-full"
              />
            </div>
          </motion.div>
        </Reveal>
      </div>
    </section>
  );
}
